<template>
  <div class="resanotif">
    <v-touch class="resanotif-container" v-on:pan="panEvent" v-on:panend="panEnd" v-on:pancancel="panCancel"
      v-on:tap="reInitPos">
      <div class="resanotif-left" @click="cancelResa">Refuser</div>
      <el-row :gutter="10" class="resanotif-row" v-bind:style="{ left: swipContentValue }">
        <el-col :span="2">
          <div class="resanotif-point"></div>
        </el-col>
        <el-col :span="18">
          <div class="resanotif-info">
            <div class="resanotif-info-title">Nouvelle réservation</div>
            <div class="resanotif-info-desc">
              <span v-if="getClientByid(resa.cid)">{{ getClientByid(resa.cid).name }} {{ getClientByid(resa.cid).prenom
                }} -
                {{ resa.nbCouvert }} couverts</span>
              <span v-if="resa.type === 'caution' && resa.amount > 0"> - C : </span>
              <span v-if="resa.type === 'prepaiement' && resa.amount > 0"> - P : </span>
              <span v-if="resa.total">{{ resa.total }}€</span>
              <span v-else-if="resa.amount !== '' && resa.amount > 0">{{ Math.round((resa.amount * resa.nbCouvert) *
                100)
                / 100}}€</span><br>
              le {{ resa.dateResa.day }} {{ resa.dateResa.labelMonth }} {{ resa.dateResa.year }} à {{
                getHourWithH(resa.hour) }}
            </div>
          </div>
        </el-col>
        <el-col :span="4" class="resanotif-btn-container">
          <div class="resanotif-btn" @click="gotoResa">
            <i class="el-icon-more"></i>
          </div>
        </el-col>
      </el-row>
      <div class="resanotif-right" @click="callAccept">Accepter</div>
    </v-touch>
    <div class="resanotif-separator"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import * as resaState from '../../store/types/resa-state';
import { dateToTimeStamp, formatTimeH, parseTime } from '../../tools/timeTool';

export default {
  name: 'ResaNotif',
  props: {
    resa: {}
  },
  data() {
    return {
      showLeft: false,
      showRight: false,
      swipContentValue: '0',
      xPosSwipe: 0,
      panStart: 0
    }
  },
  computed: {
    ...mapGetters({
      getClientByid: 'newClients/getClientByid',
      getAllInfos: 'infos/getAllInfos',
      getUidPublic: 'newUsers/getUidPublic'
    }),
    getLinkModify: function () {
      let host = `http://${window.location.hostname}`
      let ts = dateToTimeStamp(this.resa.dateResa.day, this.resa.dateResa.month - 1, this.resa.dateResa.year)
      return `${host}/change/${this.getUidPublic.toString()}/${ts.toString()}/${this.resa.id.toString()}`
    }
  },
  methods: {
    ...mapActions({
      updateStateResa: 'newReservations/updateStateResa',
      showHidePopupManageServices: 'displayer/showHidePopupManageServices',
      updateClientCount: 'newClients/updateClientCount',
      showVisibilityCalendar: 'calendar/showVisibilityCalendar',
      acceptResa: 'newReservations/acceptResa'
    }),
    ...mapMutations({
      setSelectedResa: 'newReservations/setSelectedResa',
      setResaCanceling: 'newReservations/setResaCanceling',
      setDialogCancelResa: 'displayer/setDialogCancelResa',
      setDialogPayement: 'displayer/setDialogPayement',
      setYear: 'calendar/setYear',
      setMonth: 'calendar/setMonth',
      setSelectedDay: 'calendar/setSelectedDay',
      setSelectedService: 'newServices/setSelectedService',
      setModLinkTable: 'newRooms/setModLinkTable'
    }),
    getHourWithH: function (h) {
      return formatTimeH(parseTime(h), 'H')
    },
    onSwipeLeft: function () {
      this.showLeft = false
      this.showRight = true
      this.swipContentValue = '-30%'
    },
    onSwipeRight: function () {
      this.showLeft = true
      this.showRight = false
      this.swipContentValue = '30%'
    },
    reInitPos: function (e) {
      this.showLeft = false
      this.showRight = false
      this.swipContentValue = '0'
    },
    panCancel: function (e) {
      this.panStart = 0
      this.swipContentValue = 0
    },
    panEvent: function (e) {
      if (this.panStart > 5) {
        this.xPosSwipe = e.deltaX
        if (this.xPosSwipe > 110) this.xPosSwipe = 110
        else if (this.xPosSwipe < -110) this.xPosSwipe = -110
        this.swipContentValue = `${this.xPosSwipe.toString()}px`
      }
      this.panStart++
    },
    panEnd: function () {
      if (this.swipContentValue === '110px') {
        let idCancel = window.setInterval(() => {
          this.cancelResa()
          window.clearInterval(idCancel)
        }, 100)
      } else if (this.swipContentValue === '-110px') {
        let idAccept = window.setInterval(() => {
          this.callAccept()
          window.clearInterval(idAccept)
        }, 100)
      } else {
        this.xPosSwipe = 0
        this.swipContentValue = `${this.xPosSwipe.toString()}px`
      }
      this.panStart = 0
      setTimeout(() => { this.swipContentValue = 0 }, 1000)
    },
    callAccept: function () {
      if (this.resa.type === 'prepaiement' && !this.resa.payementDone) {
        this.setSelectedResa(this.resa)
        this.setDialogPayement(true)
      } else {
        this.acceptResa({
          resa: this.resa,
          state: resaState.CONFIRMED
        })
      }
    },
    cancelResa: function () {
      this.setResaCanceling(this.resa)
      this.setDialogCancelResa(true)
    },
    gotoResa: function () {
      this.$emit('bubleclose', false)
      this.setSelectedDay(this.resa.dateResa)
      this.setSelectedService({ ms: this.resa.ms, subs: this.resa.subs })
      this.setSelectedResa(this.resa)
      this.setModLinkTable(true)
      this.showHidePopupManageServices()
      this.showVisibilityCalendar(false)
    }
  }
}
</script>

<style lang="scss">
@use "../../styles/components/elements/resanotif";
</style>
